import { defineComponent as _defineComponent } from 'vue'
import { IFilter, IOption } from "@/domain/entities/filter/filter.types";
import { computed, PropType } from "vue";


const __default__ = {
  name: "LineSearchFilterItems",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  filter: {
    type: Object as PropType<IFilter>,
    required: true,
  },
  selectedOptions: {
    type: [Object, Array, null] as PropType<IOption | IOption[] | null>,
    default: null,
  },
},
  emits: ["onClickOption"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const isEmptySelectedOptions = computed(() => {
  if (Array.isArray(props.selectedOptions)) {
    return !props.selectedOptions.length;
  } else {
    return !props.selectedOptions;
  }
});

const isSelected = (optionKey: string) => {
  if (isEmptySelectedOptions.value) {
    const defaultOption = props.filter.availableOptions.find(
      (option) => option.default
    );
    return defaultOption?.key === optionKey;
  }

  if (Array.isArray(props.selectedOptions)) {
    return props.selectedOptions.some((option) => option.key === optionKey);
  } else {
    return props.selectedOptions?.key === optionKey;
  }
};

const handleOnClickMultipleOption = (
  filter: IFilter,
  optionKey: string,
  selectedOption: IOption | undefined
) => {
  const currentSelectedOptions = Array.isArray(props.selectedOptions)
    ? props.selectedOptions
    : [];
  const index = currentSelectedOptions.findIndex(
    (option) => option.key === optionKey
  );

  let newSelectedOptions: IOption[] = [];
  if (index > -1) {
    newSelectedOptions = [...currentSelectedOptions];
    newSelectedOptions.splice(index, 1);
  } else if (selectedOption) {
    newSelectedOptions = [...currentSelectedOptions, selectedOption];
  }

  emit(
    "onClickOption",
    filter,
    newSelectedOptions.length ? newSelectedOptions : null
  );
};

const handleOnClickSingleOption = (
  filter: IFilter,
  optionKey: string,
  selectedOption: IOption | undefined
) => {
  if (
    props.selectedOptions &&
    !Array.isArray(props.selectedOptions) &&
    props.selectedOptions.key === optionKey
  ) {
    emit("onClickOption", filter, null);
  } else if (selectedOption) {
    emit("onClickOption", filter, selectedOption);
  }
};

const onClickOption = (filter: IFilter, optionKey: string) => {
  const selectedOption = props.filter.availableOptions.find(
    (option) => option.key === optionKey
  );

  if (props.filter.multiple) {
    handleOnClickMultipleOption(filter, optionKey, selectedOption);
  } else {
    handleOnClickSingleOption(filter, optionKey, selectedOption);
  }
};

const __returned__ = { props, emit, isEmptySelectedOptions, isSelected, handleOnClickMultipleOption, handleOnClickSingleOption, onClickOption }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})